import groq from "groq";

export const coalesceWithEmptyArray = (fieldName: string, fields: string, isRef = false) => {
  return groq`coalesce(${fieldName}[]${isRef ? "->" : ""}{${fields}}, [])`;
};
